import { render, staticRenderFns } from "./FabricUploadImage.vue?vue&type=template&id=5a3c8dcc&scoped=true"
import script from "./FabricUploadImage.vue?vue&type=script&lang=js"
export * from "./FabricUploadImage.vue?vue&type=script&lang=js"
import style0 from "./FabricUploadImage.vue?vue&type=style&index=0&id=5a3c8dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c8dcc",
  null
  
)

export default component.exports